import React from 'react';
import classes from './FloatingActionBar.module.scss';
import { WithChildren } from '../../../models/children-props';
import classNames from 'classnames';
import { Portal } from '../Portal';
import { useOnboardingWidgetHeight } from '../../../hooks/useOnboardingWidgetHeight';

export enum FloatingActionBoxModeEnum {
  LIGHT = 'LIGHT',
  DARK = 'DARK'
}

export type FloatingActionBarViewProps = WithChildren & {
  mode: FloatingActionBoxModeEnum;
  selectedLabel: string;
  itemsSelectedCount: number;
};

export const FloatingActionBarView = (props: FloatingActionBarViewProps): JSX.Element => {
  const containerClasses = classNames(classes.FloatingActionBar, {
    [classes.FloatingActionBarDark]: props.mode === FloatingActionBoxModeEnum.DARK
  });

  const selectedLabelWrapperClasses = classNames('cell small-12 medium-shrink', classes.selectedLabelWrapperClasses);
  const onboardingWidgetHeight = useOnboardingWidgetHeight();

  return (
    // <div style={{ display: 'flex', justifyContent: 'center', margin: 'auto' }}>
    <Portal>
      <div className={classes.FloatingActionBarPosition}>
        <div className={containerClasses} style={{ marginBottom: onboardingWidgetHeight }}>
          <div className={'grid-x'}>
            <div className={selectedLabelWrapperClasses}>
              <span className={classes.NumberOfSelectedLabel}>
                {props.itemsSelectedCount} {props.selectedLabel}
              </span>
            </div>
            {React.Children.map(props.children, (child, index) => {
              const wrapperClassNames = classNames('cell small-12 medium-shrink', {
                [classes.SiblingButton]: index > 0
              });
              return <div className={wrapperClassNames}>{child}</div>;
            })}
          </div>
        </div>
      </div>
    </Portal>
  );
};
